import api from './api';

export const getSellerComplaints = async (page = 1, pageSize = 10) =>
  (await api.get('/customer-complaints', { params: { page, pageSize } })).data;
export const getSellerComplaint = async (id: string) => (await api.get(`/customer-complaints/${id}`)).data.data;
export const submitComplaintResponse = async (id: string, message: string) => (await api.post(`/customer-complaints/${id}/responses`, { message })).data;
export const uploadComplaintAttachments = async (id: string, files: File[]) => {
  const data = new FormData(); files.forEach(file => data.append('Files', file));
  return (await api.post(`/customer-complaints/${id}/attachments`, data)).data;
};
export const requestComplaintReview = async (id: string, note: string) => (await api.post(`/customer-complaints/${id}/request-review`, { note })).data;
export const downloadComplaintAttachment = async (complaintId: string, attachmentId: string) =>
  (await api.get(`/customer-complaints/${complaintId}/attachments/${attachmentId}/download`, { responseType: 'blob' })).data;
